import { Container } from "layouts";
import { Link } from "react-router-dom";
import { FiHome, FiBookOpen, FiShield } from "react-icons/fi";

const Unauthorized = () => {
	return (
		<Container>
			<div className=" flex flex-col ">
				{/* <Header /> */}

				<div className="flex-grow flex justify-center items-center px-4">
					<div className="max-w-md w-full text-center">
						{/* Icon with animation */}
						<div className="mb-8 relative">
							<div className="w-24 h-24 mx-auto mb-4 bg-red-100 rounded-full flex items-center justify-center">
								<FiShield className="w-12 h-12 text-red-500" />
							</div>
							<div className="absolute inset-0 w-24 h-24 mx-auto border-4 border-red-200 rounded-full animate-ping opacity-20"></div>
						</div>

						{/* Error Code */}
						<div className="mb-4">
							<h1 className="text-6xl font-bold  mb-2">403</h1>
							<h2 className="text-2xl font-semibold  mb-2">Access Denied</h2>
						</div>

						{/* Message */}
						<div className="mb-8">
							<p className="text-lg text-gray-600 leading-relaxed">
								Sorry! You don't have sufficient permissions to access this
								resource.
							</p>
							<p className="text-sm text-gray-500 mt-2">
								Please contact your administrator if you believe this is an
								error.
							</p>
						</div>

						{/* Action Buttons */}
						<div className="space-y-4">
							<Link
								to="/books"
								className="inline-flex items-center justify-center w-full py-3 px-6 bg-gradient-to-b from-akgreenest to-akgreen text-white font-medium rounded-2xl shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-200"
							>
								<FiBookOpen className="w-5 h-5 mr-2" />
								Browse Books
							</Link>

							<div className="flex space-x-3">
								<Link
									to="/"
									className="flex-1 inline-flex items-center justify-center py-3 px-4 bg-white text-gray-700 font-medium rounded-xl border border-gray-200 hover:border-gray-300 hover:shadow-md transform hover:-translate-y-0.5 transition-all duration-200"
								>
									<FiHome className="w-4 h-4 mr-2" />
									Home
								</Link>
							</div>
						</div>

						{/* Help Text */}
						<div className="mt-8 p-4 bg-blue-50 rounded-xl border border-blue-100">
							<Link
								to="/support"
								className="text-sm text-blue-700"
							>
								Need help? Contact our support team{" "}
								<span className="font-bold hover:underline">here</span>
							</Link>
						</div>
					</div>
				</div>
			</div>
		</Container>
	);
};

export default Unauthorized;
